import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { SchemaHelperViewDataProvider } from '../dataProvider/SchemaHelperViewDataProvider';

export class SchemaHelperDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_GZ, SchemaHelperViewDataProvider);
  }
}
